export const graphOption = (dataPoints: number[], label: string[]) => {
  const options: Record<string, unknown> = {
    grid: {
      top: 1,
      bottom: 2,
      left: 0,
      right: 0,
      height: 64,
    },
    xAxis: {
      boundaryGap: false,
      data: label,
    },
    yAxis: {
      show: false,
    },
    series: [
      {
        data: dataPoints,
        type: 'line',
        smooth: true,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(0, 148, 145, 0.1)',
              },
              {
                offset: 1,
                color: 'rgba(0, 148, 145, 0.1)',
              },
            ],
          },
        },
        lineStyle: {
          color: '#009491',
          width: 1,
        },
        itemStyle: {
          opacity: 0,
        },
      },
    ],
  };
  return options;
};

export const weeklyComparison = (data: {
  [date: string]: number;
}): {
  currentWeekSum: number;
  previousWeekSum: number;
  percentageChange: number;
} => {
  const dates = Object.keys(data);

  // Sort the dates in ascending order
  dates.sort();

  // Get the most recent date
  const lastDate = dates[dates.length - 1];

  // Calculate the start date for the previous week
  const endDate = new Date(lastDate);
  const startDate = new Date(endDate);
  startDate.setDate(endDate.getDate() - 6);

  // Initialize sums for the current week and the previous week
  let currentWeekSum = 0;
  let previousWeekSum = 0;

  // Iterate through the dates and sum the values for the two weeks
  for (const date of dates) {
    const currentDate = new Date(date);
    const value = data[date];

    if (currentDate >= startDate && currentDate <= endDate) {
      currentWeekSum += value;
    } else if (currentDate < startDate) {
      previousWeekSum += value;
    }
  }

  // Calculate the percentage change
  const percentageChange =
    previousWeekSum !== 0
      ? Math.round(
          ((currentWeekSum - previousWeekSum) / Math.abs(previousWeekSum)) * 100
        )
      : 0;

  // Return an object with the sums and percentage change
  return {
    currentWeekSum,
    previousWeekSum,
    percentageChange,
  };
};
